module.exports = __webpack_public_path__ + "static/media/course-1.aa6ddd93.png";